import * as React from "react";
import type { SVGProps } from "react";
const SvgMapPinOnMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 11c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.217 10.884C17.69 9.845 18 8.84 18 8c0-3.53-2.47-6-6-6S6 4.47 6 8c0 .841.31 1.846.78 2.884l-1.39.696c-.24.12-.42.33-.5.58l-2.84 8.52a1.004 1.004 0 0 0 1.34 1.24l4.11-1.73 4.11 1.73c.25.1.53.1.78 0l4.11-1.73 4.11 1.73c.13.05.26.08.39.08v.01a1.008 1.008 0 0 0 .95-1.32l-2.84-8.53a.99.99 0 0 0-.5-.58zM12 18c-.3 0-.58-.13-.77-.36-.323-.382-2.125-2.58-3.525-4.984l-1.055.524-2.01 6.04 2.47-1.04c.25-.1.53-.1.78 0L12 19.91l4.11-1.73c.25-.1.53-.1.78 0l2.47 1.04-2.01-6.04-1.058-.525c-1.402 2.405-3.206 4.603-3.522 4.985-.19.23-.47.36-.77.36m0-14C9.57 4 8 5.57 8 8c0 1.67 2.21 5.08 4 7.4 1.79-2.32 4-5.73 4-7.4 0-2.43-1.57-4-4-4"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapPinOnMap;
